import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { axiosInstance } from '../../../helpers/api_helper';
import { UserPackages } from './types';
import {
  handleValidDate,
  handleValidTime,
  usdFormatter
} from '../../../helpers/helpers';

export const getTravelutionSaveAndTravelSubcriptions = createAsyncThunk(
  'getTravelutionSaveAndTravelSubcriptions/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(
      '/products/travelution-save-and-travel-subscriptions/orders',
      {
        params
      }
    );

    return response.data.data;
  }
);

export const getRevolutionSubcriptions = createAsyncThunk(
  'getRevolutionSubcriptions/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(
      '/products/travelution-getrevolution-subscriptions/orders',
      {
        params
      }
    );

    return response.data.data;
  }
);

export const updateBundleSubscriptionStatus = createAsyncThunk(
  'packageOrders/updateBundleSubscriptionStatus',
  async (
    { id, calculationStatus }: { id: number; calculationStatus: number },
    { rejectWithValue }
  ) => {
    try {
      await axiosInstance.post(
        `/products/travelution-subscription-bundles/orders/${id}/confirm?calculationStatus=${calculationStatus}`
      );
      toast.success('Successfully updated Travelution Bundle Subscription');

      return id;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

export const exportPackageOrders = createAsyncThunk(
  'packageOrders/exportPackageOrders',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(`/package/user/export`, {
      params
    });

    const dataForExport = response.data.data.userPackages.map(
      (po: UserPackages) => ({
        orderId: po?.id,
        userId: po?.user?.id,
        user: `${po?.user?.name} ${po?.user?.surname}`,
        packageName: po?.package?.name,
        amount: `${
          po?.package?.price ? usdFormatter?.format(po?.package?.price) : ''
        }`,
        paymentAddress: po?.paymentAddress || '',
        orderDate: po?.dateCreated
          ? `${handleValidDate(po?.dateCreated)}, ${handleValidTime(
              po?.dateCreated
            )}`
          : '',
        paymentDate: po?.datePaid
          ? `${handleValidDate(po?.datePaid)}, ${handleValidTime(po?.datePaid)}`
          : '',
        lockDate: po?.dateLimitForAutoStake
          ? `${handleValidDate(po?.dateLimitForAutoStake)}, ${handleValidTime(
              po?.dateLimitForAutoStake
            )}`
          : '---',
        status: statusForTable(po?.status, po?.calculationStatus)
      })
    );

    return dataForExport;
  }
);

export const exportHeaders = [
  { label: 'Order ID', key: 'orderId' },
  { label: 'User ID', key: 'userId' },
  { label: 'User', key: 'user' },
  { label: 'Package Name', key: 'packageName' },
  { label: 'Amount', key: 'amount' },
  { label: 'Payment Address', key: 'paymentAddress' },
  { label: 'Order Date', key: 'orderDate' },
  { label: 'Payment Date', key: 'paymentDate' },
  { label: 'Lock Date', key: 'lockDate' },
  { label: 'Status', key: 'status' }
];

export const statusForTable = (status: number, calculationStatus: number) => {
  switch (status) {
    case 1:
      return 'PENDING';
    case 2:
      return 'PAID';
    case 3:
      return 'CANCELED';
    case 4:
      return 'CANCELED BY USER';

    default:
      break;
  }
};

export interface PackageRankOrdersState {
  data: UserPackages[];
  loading: boolean;
  totalCount: number;
  dataForExport: UserPackages[];
  loadingExport: boolean;
}

const initialState = {
  data: [],
  totalCount: 0,
  loading: false,
  dataForExport: [],
  loadingExport: false
} as PackageRankOrdersState;

const packageOrdersSlice = createSlice({
  name: 'packageOrders',
  initialState,
  reducers: {
    removePackageOrdersForExport(state) {
      state.dataForExport = [];
    }
    // fill in primary logic here
  },
  extraReducers: (builder) => {
    //GET REVOLUTIOn SUBSCRIPTIONS
    builder.addCase(getRevolutionSubcriptions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getRevolutionSubcriptions.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.data = payload.orders;
        state.totalCount = payload.count;
      }
    );
    builder.addCase(getRevolutionSubcriptions.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { removePackageOrdersForExport } = packageOrdersSlice.actions;

export default packageOrdersSlice.reducer;
